/* globals jQuery */
import 'fitvids.1.1.0'
//import 'magnific-popup'
//import objectFitImages from 'object-fit-images';

import './slideshows.js'
import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'
import './effects.js'

(($) => {

    $('html').removeClass('no-js').addClass('js');

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav();

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    //mouse
    const buttons = document.querySelectorAll('.btn2')
    buttons.forEach(button => {
        button.addEventListener('mousemove', (e) => {
            const { x, y } = button.getBoundingClientRect();
            button.style.setProperty("--x", `${e.clientX - x}px`);
            button.style.setProperty("--y", `${e.clientY - y}px`);
        });
    });
    

    //HERO V4
    if( $('.hero').length > 0 ){
        let words = document.querySelectorAll(".word");
        words.forEach(word => {
            let letters = word.textContent.split("");
            word.textContent = "";
            letters.forEach(letter => {
                let span = document.createElement("span");
                span.textContent = letter;
                span.className = "letter";
                word.append(span);
            });
        });

        let currentWordIndex = 0;
        let maxWordIndex = words.length - 1;
        words[currentWordIndex].style.opacity = "1";

        let rotateText = () => {
            let currentWord = words[currentWordIndex];
            let nextWord = currentWordIndex === maxWordIndex ? words[0] : words[currentWordIndex + 1];
            // rotate out letters of current word
            Array.from(currentWord.children).forEach((letter, i) => {
                setTimeout(() => {
                    letter.className = "letter out";
                }, i * 80);
            });
            // reveal and rotate in letters of next word
            nextWord.style.opacity = "1";
            Array.from(nextWord.children).forEach((letter, i) => {
                letter.className = "letter behind";
                setTimeout(() => {
                    letter.className = "letter in";
                }, 340 + i * 80);
            });
            currentWordIndex =
                currentWordIndex === maxWordIndex ? 0 : currentWordIndex + 1;
        };

        setTimeout(function(){
            rotateText();
            setInterval(rotateText, 3000);
        }, 1000);
        
    }

    //Filter post stories (page for posts)
	$('#articleCategories').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

    $('.js-social-share').on("click", function(e) {
        // Prevent default anchor event
        e.preventDefault();

        // Set values for window
        let intWidth = '500';
        let intHeight = '400';
        let strResize = 'yes';
        let href = $(this).attr('href');

        // Set title and open popup with focus on it
        var strTitle = ((typeof $(this).attr('title') !== 'undefined') ? $(this).attr('title') : 'Social Share'),
            strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,            
            objWindow = window.open(href, strTitle, strParam).focus();
    });


})(jQuery)
